import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { ExternalComponentService } from 'app/infrastructure/services/externalComponent.service';
import { ExternalComponent } from 'app/infrastructure/model/classes/externalComponent.class';

@Component({
    selector: 'sx-external-component-list',
    templateUrl: './list.external-component.component.html',
})
export class ExternalComponentListComponent implements OnInit {
    public searchPage: string;
    public searchInteractionRule: string;

    systemCode: string;
    askToDelete = [];

    components: ExternalComponent[] = [];

    constructor(private externalComponentService: ExternalComponentService,
        private router: Router,
        private aRoute: ActivatedRoute,
        private alertService: AlertService) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {

            this.systemCode = params['codsistema'];

            this.externalComponentService.getAll(this.systemCode).subscribe(
                x => { this.components = x; });
        });
    }

    clickEdit(alias: string) {
        this.router.navigate(['.', alias], { relativeTo: this.aRoute });
    }

    clickDelete(alias: string) {
        this.externalComponentService.delete(this.systemCode, alias)
            .then(success => {
                if (success) {
                    this.alertService.showGrowl({
                        type: GrowlType.SUCCESS,
                        body: 'EXTERNAL_COMPONENT_DELETE_SUCCESS',
                    }, { alias: alias });
                } else {
                    this.alertService.showGrowl({
                        type: GrowlType.DANGER,
                        body: 'SOC_FE_0012_COULD_NOT_DELETE_EXTERNAL_COMPONENT_WITH_ALIAS',
                    }, { alias: alias });
                }
                this.components = this.components.filter(c => c.alias !== alias);
            });
    }

    back() {
        this.router.navigate(['../'], { relativeTo: this.aRoute });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/external-component/list.external-component.component.ts